import { createMasterCompany } from "api/masterCompany.api";
import MasterCompanyForm from "components/masterCompanies/masterCompanyForm";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { organizerRoute } from "../../../utils/permissionRoute";
import Toast from "components/Toast";
export default function MasterCompanyCreate() {
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });
  const navigate = useNavigate();
  const [alert, setAlert] = useState("");

  const handleSubmit = async (data) => {
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        // // 4. Check File upload
        // if (key === "companyLogo" && value instanceof File) {
        //   formData.append("companyLogo", value);
        // }
        // 5. General primitive values LAST
        formData.append(key, value);
      });

      // 🔍 Correct way to log FormData contents
      console.log("FormData Entries:", Object.fromEntries(formData.entries()));

      await createMasterCompany(formData);
      setToast({
        open: true,
        title: "Created Successfully!",
        message: "Master company has been created successfully.",
        type: "success",
      });
      // navigate("/admin/master");
    } catch (err) {
      console.error("API ERROR:", err.response?.data || err.message);
      setAlert(
        err.response?.data?.message || "Something went wrong. Try again."
      );
    }
  };

  return (
    <>
      <MasterCompanyForm
        onSubmit={handleSubmit}
        submitLabel="Create Master Company"
        alert={alert}
        setAlert={setAlert}
        onBack={() => navigate(-1)}
        organizerRoute={organizerRoute}
      />
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={4000}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          // 3. Navigate after toast closes/timer finishes
          navigate("/admin/master");
        }}
      />
    </>
  );
}
